
import { getConfig } from "../../../hooks/use-config";

export const defaultProductFilters = {
  minVolume: +getConfig("minContainerVolume"),
  maxVolume: +getConfig("maxContainerVolumeFilter"),

  minPrice: +getConfig("minProductPrice"),
  maxPrice: +getConfig("maxProductPrice"),
};
